<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<lcsj-filter :show-search="false" more-text="更多筛选" @search="inputChange()">
			<template #query>
				<el-button v-if="$checkBtnPermission('/processPurchase/index', 'viewPage')" size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
				<el-button v-if="$checkBtnPermission('/processPurchase/index', 'reset')" size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
			</template>
			<template #actions><el-button plain v-if="$checkBtnPermission('/processPurchase/index', 'export')" size="small" type="warning" icon="el-icon-s-promotion" :loading="exportLoading" @click="handleExport">导出</el-button><el-button plain v-if="$checkBtnPermission('/processPurchase/index', 'editSupply')" size="small" icon="el-icon-edit" @click="handleEditSupply">修改供应商</el-button><el-button plain v-if="$checkBtnPermission('/processPurchase/index', 'inputStore')" size="small" type="primary" icon="el-icon-upload2" @click="handleInputStore">入库</el-button><el-button plain v-if="$checkBtnPermission('/processPurchase/index', 'cancel')" size="small" type="danger" @click="handleCancelPurchase">取消</el-button><el-button plain v-if="$checkBtnPermission('/processPurchase/index', 'delete')" size="small" type="danger" class="el-icon-delete" @click="handleDeletePurchase">删除</el-button></template>
			<el-form-item label="采购单号：">
					<el-input clearable v-model="formInline.purchaseNo" size="small" placeholder="请输入采购单号" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="加工单号：">
					<el-input clearable v-model="formInline.processOrderNo" size="small" placeholder="请输入加工单号" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="是否入库：">
					<el-select v-model.number="formInline.isInputStore" placeholder="请选择是否入库" size="small" width="120">
						<el-option label="全部" :value="0"></el-option>
						<el-option label="已入库" :value="1"></el-option>
						<el-option label="未入库" :value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="是否导出：">
					<el-select v-model.number="formInline.isExport" placeholder="请选择是否导出" size="small" width="120">
						<el-option label="全部" :value="0"></el-option>
						<el-option label="已导出" :value="1"></el-option>
						<el-option label="未导出" :value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="商品信息：">
					<el-cascader
						v-model="goodsTypeValue"
						size="small"
						:options="goodsTypeList"
						:props="cascaderProps"
						placeholder="请选择商品信息"
						clearable
						filterable
						@change="handleTypeChange"
					></el-cascader>
				</el-form-item>
				<el-form-item label="球镜：">
					<el-select v-model="formInline.qiuJingKeyId" placeholder="请选择球镜" clearable size="small" filterable @change="search">
						<el-option v-for="item in qiuJingList" :key="item.keyId" :label="item.paramsValue" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="柱镜：">
					<el-select v-model="formInline.zhuJingKeyId" placeholder="请选择柱镜" clearable size="small" filterable @change="search">
						<el-option v-for="item in zhuJingList" :key="item.keyId" :label="item.paramsValue" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="需求时间：">
					<el-date-picker
						v-model="dateValue"
						clearable
						size="small"
						type="daterange"
						value-format="yyyy-MM-dd"
						format="yyyy-MM-dd"
						range-separator="~"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						@change="handleDateChange"
					></el-date-picker>
				</el-form-item>
				<el-form-item label="顾客姓名：">
					<el-input clearable v-model="formInline.customerName" size="small" placeholder="请输入顾客姓名" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="顾客电话：">
					<el-input clearable v-model="formInline.customerPhone" size="small" placeholder="请输入顾客电话" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
			</lcsj-filter>
			<STable :columns="columnsData" :data="listData" :loading="loading" border height="470" @get-data="getListData" @selection-change="handleSelectionChange">
				<template #processOrderNo>
					<el-table-column align="center" label="加工单号" min-width="220">
						<template #default="scope">
							<el-link type="primary" @click="handleSeeOrderDetail(scope.row)">{{ scope.row.processOrderNo }}</el-link>
						</template>
					</el-table-column>
				</template>
				<template #lR>
					<el-table-column align="center" label="左右眼" min-width="90">
						<template #default="scope">
							<span v-if="scope.row.lr === 1">左眼</span>
							<span v-else-if="scope.row.lr === 0">右眼</span>
						</template>
					</el-table-column>
				</template>
				<template #stateStr>
					<el-table-column align="center" label="状态" min-width="100">
						<template #default="scope">
							<span v-if="scope.row.state === 2" class="text-success">已入库</span>
							<span v-else-if="scope.row.state === 3" class="text-danger">已取消</span>
							<span v-else>采购中</span>
						</template>
					</el-table-column>
				</template>
				<template #isExport>
					<el-table-column align="center" label="是否导出" min-width="100">
						<template #default="scope">
							<span v-if="scope.row.isExport" class="text-success">已导出</span>
							<span v-else class="text-danger">未导出</span>
						</template>
					</el-table-column>
				</template>
			</STable>
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		</topTab>

		<selectSupply ref="selectSupply"></selectSupply>
		<processOrderDetail ref="processOrderDetail"></processOrderDetail>
		<exportBlockDialog :visible.sync="exportBlockVisible" :title="exportBlockTitle" :blocks="exportBlockData" />
	</div>
</template>

<script>
import { GetProcessPurchasePageList, ExportProcessPurchaseOrder, EditProcessPurchaseSupply, InputStoreByProcessPurchase, DeleteProcessPurchaseOrder, CancelProcessPurchaseOrder } from "@/api/processApi.js";
import { GetAllGoodsTypeTreePageList, GetGoodsParamsList } from "@/api/baseDataApi.js";
import { exportWithLoading } from "@/api/exportFile";
import exportBlockDialog from "@/components/exportBlockDialog.vue";
import selectSupply from "@/views/baseData/supply/selectSupply.vue";
import processOrderDetail from "@/views/baseData/processOrder/order/detail.vue";
export default {
	components: {
		selectSupply,
		processOrderDetail,
		exportBlockDialog
	},
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "采购单列表"
				}
			],
			pageShow: true,
			loading: false,
			exportLoading: false,
			listData: [],
			selectionRowKeyIds: [],
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			dateValue: [],
			goodsTypeList: [],
			goodsTypeValue: [],
			qiuJingList: [],
			zhuJingList: [],
			cascaderProps: {
				value: "keyId",
				label: "name",
				children: "subList",
				checkStrictly: true,
				expandTrigger: "click"
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				purchaseNo: "",
				processOrderNo: "",
				isInputStore: 0,
				isExport: 0,
				goodsTypeKeyId: "",
				qiuJingKeyId: "",
				zhuJingKeyId: "",
				customerName: "",
				customerPhone: "",
				orderDateStart: null,
				orderDateEnd: null
			},
			columnsData: [],
			listColumns: [
				{ prop: "keyId", label: "全选", align: "center", width: "55", isKeep: true, selection: true },
				{ prop: "rowNumber", label: "序号", align: "center", width: "70", isKeep: true },
				{ prop: "purchaseNo", label: "采购单号", align: "center", isKeep: true, width: "200" },
				{ slot: "processOrderNo", label: "加工单号", align: "center", isKeep: true, width: "220" },
				{ prop: "belongStoreName", label: "需求门店", align: "center", isKeep: true, width: "130" },
				{ prop: "customerName", label: "顾客姓名", align: "center", isKeep: true, width: "100" },
				{ prop: "goodsBrand", label: "商品品牌", align: "center", isKeep: true, width: "140" },
				{ prop: "goodsName", label: "商品名称", align: "center", isKeep: true, minWidth: "200" },
				{ prop: "qiuJing", label: "球镜", align: "center", width: "80" },
				{ prop: "zhuJing", label: "柱镜", align: "center", width: "80" },
				{ slot: "lR", label: "左右眼", align: "center", width: "90" },
				{ prop: "zhouWei", label: "轴位", align: "center", width: "80" },
				{ prop: "quantity", label: "采购数量", align: "center", width: "90" },
				{ prop: "supplyName", label: "所属供应商", align: "center", width: "150" },
				{ slot: "stateStr", label: "状态", align: "center", isKeep: true, width: "100" },
				{ slot: "isExport", label: "是否导出", align: "center", width: "100" },
				{ prop: "exportDate", label: "导出时间", align: "center", width: "170" },
				{ prop: "orderDate", label: "需求时间", align: "center", width: "170" },
				{ prop: "remark", label: "备注", align: "center", minWidth: "140" },
				{ prop: "creator", label: "创建人", align: "center", width: "100" },
				{ prop: "createTime", label: "创建时间", align: "center", width: "170" }
			],
			exportBlockVisible: false,
			exportBlockTitle: "",
			exportBlockData: []
		};
	},
	created() {
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.getListData();
		this.GetAllGoodsTypeTreePageList();
		this.GetGoodsParamsList();
	},
	methods: {
			changePages(tab) {
				this.activeTab = tab;
			},
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		GetAllGoodsTypeTreePageList() {
			GetAllGoodsTypeTreePageList({})
				.then((res) => {
					if (res.code == 1) {
						this.goodsTypeList = res.data || [];
					}
				})
				.catch(() => {});
		},
		GetGoodsParamsList() {
			GetGoodsParamsList({})
				.then((res) => {
					if (res.code == 1) {
						this.qiuJingList = (res.data || []).filter((item) => item.type == 1);
						this.zhuJingList = (res.data || []).filter((item) => item.type == 2);
					}
				})
				.catch(() => {});
		},
		handleTypeChange(value) {
			this.formInline.goodsTypeKeyId = value && value.length > 0 ? value[value.length - 1] : "";
			this.search();
		},
		handleDateChange(val) {
			if (val) {
				this.formInline.orderDateStart = val[0];
				this.formInline.orderDateEnd = val[1];
			} else {
				this.formInline.orderDateStart = null;
				this.formInline.orderDateEnd = null;
			}
			this.search();
		},
		getListData() {
			this.loading = true;
			GetProcessPurchasePageList(this.formInline)
				.then((res) => {
					this.loading = false;
					if (res.code == 1) {
						this.listData = res.data || [];
						this.pageparm.total = res.totalNumber;
					} else {
						this.listData = [];
						this.$message({ type: "info", message: res.msg });
					}
				})
				.catch(() => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline;
			this.dateValue = [];
			this.goodsTypeValue = [];
			this.search();
		},
		inputChange() {
			this.search();
		},
		callFather(parm) {
			this.formInline.pageIndex = parm.currentPage == undefined ? 1 : parm.currentPage;
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		handleSelectionChange(val) {
			this.selectionRowKeyIds = (val || []).map((item) => item.keyId);
		},
		handleExport() {
			if (this.selectionRowKeyIds.length == 0) {
				this.$message({ type: "info", message: "请选择要导出的数据" });
				return;
			}
			this.$confirm("确定要导出选中的数据吗?", "信息", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					exportWithLoading(
						this,
						"exportLoading",
						() =>
							ExportProcessPurchaseOrder({
								keyIds: this.selectionRowKeyIds
							}),
						"导出失败，请稍后再试！"
					).then(() => {
						this.getListData();
					});
				})
				.catch(() => {});
		},
		handleEditSupply() {
			if (this.selectionRowKeyIds.length == 0) {
				this.$message({ type: "warning", message: "请选择要修改供应商的采购商品信息！" });
				return;
			}
			this.$refs.selectSupply.showSelectCustomerDialog();
		},
		chooseSupply(keyId) {
			this.loading = true;
			EditProcessPurchaseSupply({
				keyIds: this.selectionRowKeyIds,
				supplyKeyId: keyId
			})
				.then((res) => {
					if (res.code == 1) {
						this.$message({ type: "success", message: "修改成功" });
						this.search();
					} else {
						this.$message({ type: "info", message: res.msg });
					}
				})
				.finally(() => {
					this.loading = false;
				});
		},
		handleInputStore() {
			if (this.selectionRowKeyIds.length == 0) {
				this.$message({ type: "warning", message: "请选择要入库的采购商品！" });
				return;
			}
			this.$confirm("确定要将选中的采购商品入库吗？入库后工厂店库存将增加。", "信息", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					this.loading = true;
					InputStoreByProcessPurchase({ keyIds: this.selectionRowKeyIds })
						.then((res) => {
							if (res.code == 1) {
								this.$message({ type: "success", message: res.msg, duration: 5000 });
								this.search();
							} else {
								this.$message({ type: "info", message: res.msg });
							}
						})
						.finally(() => {
							this.loading = false;
						});
				})
				.catch(() => {});
		},
		handleCancelPurchase() {
			if (this.selectionRowKeyIds.length == 0) {
				this.$message({ type: "warning", message: "请选择要取消的采购商品！" });
				return;
			}
			this.$confirm("确定要取消选中的采购商品吗？取消后关联订单将回到「待加工」。", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					this.loading = true;
					CancelProcessPurchaseOrder({ keyIds: this.selectionRowKeyIds })
						.then((res) => {
							if (res.code == 1) {
								this.$message({ type: "success", message: "取消成功" });
								this.search();
							} else {
								this.$message({ type: "info", message: res.msg });
							}
						})
						.finally(() => {
							this.loading = false;
						});
				})
				.catch(() => {});
		},
		handleDeletePurchase() {
			if (this.selectionRowKeyIds.length == 0) {
				this.$message({ type: "warning", message: "请选择要删除的采购商品！" });
				return;
			}
			this.$confirm("确定要删除选中的采购商品吗?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					this.loading = true;
					DeleteProcessPurchaseOrder({ keyIds: this.selectionRowKeyIds })
						.then((res) => {
							if (res.code == 1) {
								this.$message({ type: "success", message: "删除成功" });
								this.search();
							} else {
								this.$message({ type: "info", message: res.msg });
							}
						})
						.finally(() => {
							this.loading = false;
						});
				})
				.catch(() => {});
		},
		handleSeeOrderDetail(row) {
			if (!row.processOrderKeyId) {
				this.$message({ type: "info", message: "该采购单未关联加工订单！" });
				return;
			}
			this.$refs.processOrderDetail.showSeeDetailDialog({ keyId: row.processOrderKeyId });
		}
	}
};
</script>

<style scoped>
.text-danger {
	color: var(--app-danger);
}
.text-success {
	color: var(--app-success);
}
</style>
